import { SiteData } from "./Data/SiteData";
import { EditorState } from "./EditorTypes";
import { DesktopIcon, MobileIcon, TabletIcon } from "./Icons/ScreenSizeIcons";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import fadeInElement from "./Utilities/ElementAnimator";
import WebDesigner from "./WebDesigner";
import React, { useEffect } from "react";
import LayoutNode from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import StaticRender from "./StaticRender";
import {  SetGlobalCurrentPageId, SetPreviewCluster } from "vagaro-website-rendering/src/components/Utilities/WindowUtils";


export default function PreviewScreen({
  root, 
  webDesigner,
  onDismiss,
  edgeSize,
  siteData,
  onSelect,
  showFooter
}: {
  root: LayoutNode;
  webDesigner?: WebDesigner;
  siteData:SiteData;
  edgeSize?:number;
  onDismiss?: () => void;
  onSelect?: ()=>void;
  showFooter?:boolean;
}) {

 SetGlobalCurrentPageId(siteData.currentPageId);//initialize current page

  const popupRef = React.useRef<HTMLDivElement>(null);
  const contentRef = React.useRef<HTMLDivElement>(null);
  //const [width, setWidth] = React.useState<number>(5000);
  const widthRef = React.useRef<number>(5000);
  const [isLeftResize, setIsLeftResize] = React.useState<boolean>(false);
  const [isResizing, setIsResizing] = React.useState<boolean>(false);
  const [hasFaded, setHasFaded] = React.useState<boolean>(false);
  const [hardToggle,setHardToggle] = React.useState<boolean>(false);
  const onMouseResize = (e: MouseEvent) => {
    if (contentRef.current && isResizing) {
      let newWidth = isLeftResize
        ? e.clientX - contentRef.current.getBoundingClientRect().left
        : contentRef.current.getBoundingClientRect().right - e.clientX;
      if (newWidth < 300) newWidth = 300;
      widthRef.current = newWidth;
      contentRef.current.style.width = newWidth + "px";

    
      updateCTAStyle();
      //setWidth(newWidth);
    }
  };

  const GetCTAButtonStyle = ()=>{

    let w = widthRef.current;
    let maxW = window.innerWidth-50;
    if(w>maxW)
      w = maxW;
    return `
     .cta-container{
 
       width: ${w-6}px !important;
       left: ${window.innerWidth/2-w/2}px !important;
       bottom:22px !important;
       max-width:${maxW}px !important;
     }
   
   `
 
   }
   const updateCTAStyle=()=>{
     let ctaDom = document.getElementById("cta-style");
         if(ctaDom){
         
           ctaDom.innerHTML = GetCTAButtonStyle();
         }
   
   }


  const setWidth=( newWidth:number)=>{
    widthRef.current = newWidth;
    if(contentRef.current)
    contentRef.current.style.width = newWidth + "px";


    updateCTAStyle();

    setHardToggle(!hardToggle);
  }


  const startResize = (isLeft: boolean) => {
    setIsLeftResize(isLeft);
    setIsResizing(true);
  };

  const stopResize = () => {
    setIsResizing(false);
  };

  const preventTouch = (e: TouchEvent) => {

    if(isResizing){
      e.preventDefault();
      e.stopPropagation();
    }
  }
//eslint-disable-next-line
  useEffect(() => {
    document.addEventListener("pointermove", onMouseResize);
    document.addEventListener("pointerup", stopResize);
    document.addEventListener("touchmove", preventTouch, { passive: false });
    window.addEventListener("resize",    updateCTAStyle);



    if (popupRef.current && !hasFaded) {
      fadeInElement(popupRef.current, 300);
      setHasFaded(true);
    }

    return () => {
      document.removeEventListener("pointermove", onMouseResize);
      document.removeEventListener("pointerup", stopResize);
      document.removeEventListener("touchmove", preventTouch);
      window.removeEventListener("resize",    updateCTAStyle);

     SetPreviewCluster("");//clear preview cluster

    };
  },);

  const resizeStyle = {
    height: "100%",
    padding: "0 4px",
    flexGrow: "0",
    flexShrink: "0",
    cursor: "col-resize",
    display: "flex",
    gap:"8px",
    alignItems: "center",
    color:"#777",
    justifyContent: "center",
  };


  let currentScreenSize = ScreenSize.Desktop;

 
  if(widthRef.current<=768){
    currentScreenSize = ScreenSize.Mobile
  }
  else if(widthRef.current<=1200)
  currentScreenSize = ScreenSize.Tablet

  let edge = edgeSize??0;

  return (
    <div
      ref={popupRef}
      className="preview-screen flex-column"
      style={{
        position: "fixed",
        top: edge+"px",
        left: edge+"px",
        width: (edge>0)?`calc(100vw - ${edge*2}px)` :"100vw",
        height: (edge>0)? `calc(100vh - ${edge*2}px)`:"100vh",
        borderRadius:(edge>0)?"8px":"0px",
        background: "white",
        opacity: "0",
        padding: "2px 8px 16px 8px",
        zIndex: 2000,
      }}
    >
      <div className="preview-top-row flex-row justify-between" style={{padding:"0 8px"}}>
   

        <h2
          className="panel-heading"
          style={{ fontWeight: "600", fontSize: "20px"}}
        >
          Preview
        </h2>
        <div className="preview-option-row center-all" style={{margin:0}}>
          
          <button className ={"desktop preview-option center-all invisible-button "+(currentScreenSize==ScreenSize.Desktop?"selected":"")}   onClick={()=>setWidth(5000)} ><DesktopIcon/></button>
          <button className ={"tablet preview-option center-all invisible-button "+(currentScreenSize==ScreenSize.Tablet?"selected":"")}     onClick={()=>setWidth(1000)} ><TabletIcon/></button>
          <button className ={"mobile preview-option center-all invisible-button "+(currentScreenSize==ScreenSize.Mobile?"selected":"")}     onClick={()=>setWidth(400)} ><MobileIcon/></button>
      </div>
        <button
          className="invisible-button"
          style={{ fontSize: "30px", fontWeight: "700",color:"#333" }}
          onClick={() => {
            if(webDesigner){
            webDesigner.switchToEditorState(EditorState.Normal);
            SetGlobalCurrentPageId(siteData.currentPageId);//switch back to correct page id
            }
            else if(onDismiss){
              onDismiss();
            }
          }}
        >
          &times;
        </button>
      </div>
      <div className="center-all font-small" style={{padding:"4px",opacity:".6"}}>Features such as login, booking and external links are disabled while previewing</div>
      <div
        className="flex-row justify-center previewheight"
        style={{ height: "10px",flexGrow:"1000",position:"relative" }}
      >
        <div
          key="resize-1"
          className="flex-column"
          style={resizeStyle}
          onPointerDown={(e) => {
            startResize(false);
          }}
        >  <GripDots />
      
        </div>
        <style id="cta-style">
          {GetCTAButtonStyle()
          }
        </style>
        <div
          id = "preview-content"
          className="preview-content"
          style={{
            height: "100%",
           
            width: widthRef.current + "px",
            maxWidth: "100%",
            scrollBehavior: "smooth",
        
          }}
          ref={contentRef}
        >
          <div id="tost-preview-root"></div>
          {/* <iframe className="w-full h-ufll" style={{pointerEvents:(isResizing?"none":"all")}} src={window.location.origin+webDesigner?.getPreviewLink()} key="previewFrame"> </iframe> */}
         <StaticRender root={root} userContext={siteData.userContext} siteData={siteData} key="preview-rendering"/>
        </div>
        <div
          key="resize-2"
          className="flex-column"
          style={resizeStyle}
          onPointerDown={(e) => {
            startResize(true);
          }}
        >  <GripDots />
      
        </div>
      </div>
          {showFooter&&<div id="btn-row" className="flex-row justify-end gap-med" style={{padding:"12px 20px 0px 12px"}}>
          <button className="w-button w-button-secondary" onClick={onDismiss}>Cancel</button>
            <button className="w-button w-button-primary" onClick={onSelect}>Continue</button>
        
          </div>
          }
    </div>
  );
}

function GripDots() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 512"
      height="24"
      fill="currentColor"
    >
      <path d="M64 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM96 416a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96-288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM192 448a32 32 0 1 0 0-64 32 32 0 1 0 0 64z" />
    </svg>
  );
}
